import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { PRES, TYPE } from '../chrome';

interface AdminConfirmDialogProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  danger?: boolean;
}

const AdminConfirmDialog: React.FC<AdminConfirmDialogProps> = ({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  onCancel,
  onConfirm,
  danger = false,
}) => (
  <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
    <DialogTitle sx={{ fontFamily: TYPE.ui, ...TYPE.title }}>{title}</DialogTitle>
    <DialogContent>
      <Typography sx={{ fontFamily: TYPE.ui, ...TYPE.body, color: PRES.textSecondary }}>
        {body}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} sx={{ textTransform: 'none' }}>{cancelLabel}</Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        sx={{
          bgcolor: danger ? PRES.danger : PRES.interactive,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': { bgcolor: danger ? PRES.danger : PRES.interactiveHover },
        }}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AdminConfirmDialog;
